import { jsx as _jsx } from "react/jsx-runtime";
import { ViewProgram } from '@src/components/Employee/Programs/ViewProgram';
import { ApproveCard } from '@src/components/Manager/ApproveCard';
import { ProgramContextProvider } from '@src/contexts/ProgramContextProvider';
import { usePrograms } from '@src/hooks/usePrograms';
export const ProgramApproval = ({ approval }) => {
    const { find, loading } = usePrograms({
        employeeId: approval.employeeId,
        isCurrentUser: false,
        excludeSingleExpenses: false,
    });
    const program = find(approval.workflowableId);
    if (loading || !program)
        return null;
    return (_jsx(ProgramContextProvider, { program: program, children: _jsx(ViewProgram, { program: program, approval: approval, hideDocuments: true, children: _jsx(ApproveCard, { approval: approval }) }) }));
};
